/**
 * useConsoleHealth — GET /realtime-console/health TanStack Query v5
 * queryKey: ['realtime-console', 'health']
 */
import { useQuery } from '@tanstack/react-query';
import { realtimeConsoleApi } from '../api/realtimeConsoleApi';

export function useConsoleHealth() {
  return useQuery({
    queryKey: ['realtime-console', 'health'],
    queryFn: () => realtimeConsoleApi.health(),
    staleTime: 30_000,
    refetchInterval: 30_000, // 30초마다 자동 갱신
    retry: 2,
  });
}
